// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__lgVR3","productName":"Table_productName__U3-N0"};